module.exports = __webpack_public_path__ + "img/pet-header.d6e96563.png";